export function macAddressComparator(a?: string, b?: string): number {
	return makeComparableMacAddress(a ?? '') - makeComparableMacAddress(b ?? '');
}

function makeComparableMacAddress(value: string): number {
	const numericValue = parseInt(value.replace(/:/g, ''), 16);
	if (isNaN(numericValue)) {
		return Infinity;
	}
	return numericValue;
}
